import { AbortedError } from 'src/common/api/extended-emerald-error';
import { CardType } from 'src/common/enumerations/card-type';
import { EwicCaller } from 'src/common/enumerations/request-ewic-caller';
import { TenderAmountExceededEligibilityAmount } from 'src/common/helpers/error-code';
import { getValueAsNumber } from 'src/common/helpers/number-helper';
import { ITenderAdd } from 'src/common/interfaces/dtos/IPreTenderAdd';
import { EpsData } from 'src/devices/payment/dtos/eps-data';
import { EntryMethod } from '../../common/enumerations/entry-method';
import { ITender } from '../../common/interfaces/dtos/ITender';
import { preMakeTenderPayment } from '../../home-page/business-logic/pre-make-tender-payment';
import { TenderParameters } from '../interfaces/tender-parameters';
import { BuildLineTenderProps, buildTenderAddDTO } from './build-line-tender';
import { showEwicErrorModal } from './handle-ewic-error-handling';

export const EwicError = 'EwicError';

export const processPreAddTenderEwic = async (
  buildLineProps: BuildLineTenderProps,
  requestCall: EwicCaller,
  epsData: EpsData,
  firstRun: boolean = true,
): Promise<void> => {
  let lineTender: ITenderAdd = buildTenderAddDTO(buildLineProps, epsData);
  switch (requestCall) {
    case EwicCaller.Initial: {
      const missingParams: TenderParameters[] = [
        { name: 'DoPrePaymentTermValidation', value: 'true' },
      ];
      const buildLineTenderProps: BuildLineTenderProps = {
        ...buildLineProps,
        ewicEpsPrescriptionData: {
          ...buildLineProps.ewicEpsPrescriptionData,
          enabledEpsData: true,
          enabledCancel: false,
        },
        amount: 0,
      };
      lineTender = {
        ...buildTenderAddDTO(buildLineTenderProps),
        tender: {
          tenderId: buildLineProps.tender.id,
          extendedPaymentParameters: missingParams,
          entryMethod: EntryMethod.Empty,
          cancel: false,
          processedByEps: true,
        },
      };
      break;
    }

    case EwicCaller.Cancel: {
      buildLineProps = {
        ...buildLineProps,
        ewicEpsPrescriptionData: {
          ...buildLineProps.ewicEpsPrescriptionData,
          enabledEpsData: false,
          enabledCancel: true,
        },
      };

      lineTender = {
        ...buildTenderAddDTO(buildLineProps),
        tender: {
          tenderId: buildLineProps.tender.id,
          entryMethod: EntryMethod.Empty,
          cancel: true,
          processedByEps: true,
        },
      };
      break;
    }
  }

  return preMakeTenderPayment(lineTender).catch(async err => {
    if (firstRun && err.code === TenderAmountExceededEligibilityAmount) {
      const maxAllowedAmount = getValueAsNumber(err.data?.eligibility?.maxEligibleAmount);
      if (maxAllowedAmount > 0) {
        buildLineProps.amount = maxAllowedAmount;
        return processPreAddTenderEwic(buildLineProps, requestCall, epsData, false);
      }
    }

    await showEwicErrorModal(err);
    throw new AbortedError(EwicError);
  });
};

export const isEwic = (tender: ITender, epsData: EpsData): boolean => {
  return (
    epsData.card.cardType?.toUpperCase() === CardType.Ewic &&
    !!tender.tenderReferences?.includes(epsData.card.cardCode ?? '')
  );
};
